import * as React from "react";

// MUI
import Box from '@mui/material/Box';

// Custom
import AppPage from "@/ui/AppPage/AppPage";
import PlaninarskeUdrugeTable from "./PlaninarskeUdrugeTable";
import { Permissions } from "@/lib/permissions";

function PlaninarskeUdrugePage() {
  return (
    <AppPage needPermission={[Permissions.HPSSharedView, Permissions.Administration]}>
      <Box m={0} style={{ height: "100%" }}>
        <PlaninarskeUdrugeTable/>
      </Box>
    </AppPage>
  );
}

export default PlaninarskeUdrugePage;
